<template>
    <b-modal v-model="mostrarModalConsultoria" @show="preencher()" @hide="fecharModal()" @close="fecharModal()">
        <div slot="modal-title">
            Consultoria -
            <b-badge variant="warning">{{ operacaoProp }}</b-badge>
        </div>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Nome da Consultoria</label>
                    <b-input-group>
                        <b-form-input type="text" v-model="nomeConsultoria"></b-form-input>
                        <b-form-invalid-feedback> O nome é Obrigatório </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Total Previsto(Horas)</label>
                    <b-input-group>
                        <b-form-input type="number" v-model="totalPrevisto"></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Total Realizado(Horas)</label>
                    <b-input-group>
                        <b-form-input type="number" v-model="totalRealizado" disabled></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button variant="primary" :disabled="$v.$invalid" @click.stop="salvar()" class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        operacao: {
            type: String,
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        consultoria: {
            type: Object,
            default: () => { }
        },

        acao: {
            type: Object,
            default: () => { }
        },

        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        nomeConsultoria: {
            required
        }
    },

    data() {
        return {
            mostrarModalConsultoria: false,
            nomeConsultoria: null,
            totalPrevisto: null,
            totalRealizado: null,
            idConsultoria: null,
            operacaoProp: 'INSERÇÃO'
        }
    },

    methods: {
        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar() {
            this.mostrarModalConsultoria = false
            this.nomeConsultoria = ""
            this.totalPrevisto = 0
            this.totalRealizado = 0
            this.idConsultoria = 0
        },

        preencher() {
            this.nomeConsultoria = this.consultoria.nomeConsultoria
            this.totalPrevisto = this.consultoria.totalPrevisto
            this.totalRealizado = this.consultoria.totalRealizado
            this.idConsultoria = this.consultoria.idConsultoria
        },

        salvar() {
            let consultoriaDto = {
                nomeConsultoria: this.nomeConsultoria,
                totalPrevisto: this.totalPrevisto,
                totalRealizado: this.totalRealizado,
                idAcaoPlanoTrabalho: this.acao.idAcaoPlanoTrabalho,
                idConsultoria: this.idConsultoria
            }
            this.$emit('salvar', consultoriaDto)
            this.resetar()
        },
    },

    watch: {
        mostrarModal() {
            this.mostrarModalConsultoria = this.mostrarModal
            if (this.operacao == 'A') {
                this.operacaoProp = 'ATUALIZAÇÃO'
            }
        },
    },
}
</script>
